import { FadeIn } from "@/components/FadeIn";

export default function About() {
  return (
    <section id="about" className="py-32 md:py-44">
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
        <FadeIn>
          <p className="label-eyebrow mb-6">Hinter Oratiorede</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal leading-[1.1]">
            Aus einer eigenen Sprachlosigkeit entstanden.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15}>
          <div className="mt-12 space-y-6 font-serif text-lg md:text-xl text-ink leading-[1.85] text-left md:text-center">
            <p>
              Oratiorede ist kein Software-Produkt. Es ist ein stiller Versuch,
              das zu bauen, was uns selbst in einer Trauer gefehlt hat:
              ein ruhiger Rahmen, eine Reihe behutsamer Fragen, ein erstes Blatt,
              das nicht leer ist.
            </p>
            <p>
              Wir sind keine Trauerrednerinnen — und ersetzen auch keine.
              Wir sind ein Werkzeug. Eines, das nichts hinzudichtet,
              was Sie nicht gesagt haben.
            </p>
            <p className="font-serif italic text-charcoal">
              Was Sie aus den Worten machen, gehört Ihnen.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
